import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from 'styled-components'
import { Basket2Fill } from 'react-bootstrap-icons'
import { usePopper } from 'react-popper'
import AiOutlineClose from '@meronex/icons/ai/AiOutlineClose'

import {
  Wrapper,
  HeaderItem,
  PopoverBody,
  PopoverArrow,
  TitleContainer,
  Title
} from './styles'

import { useOrder, useEvent, useLanguage } from '~components'
import {
  CartContent,
  Modal,
  Button
} from '~ui'

export const CartPopover = (props) => {
  const { open, auth, location, isCustomerMode, setPreorderBusiness } = props
  const [orderState] = useOrder()
  const theme = useTheme()
  const [events] = useEvent()
  const [, t] = useLanguage()
  const referenceElement = useRef()
  const popperElement = useRef()
  const arrowElement = useRef()
  const [isFixed, setIsFixed] = useState(false)
  const popper = usePopper(referenceElement.current, popperElement.current, {
    placement: theme?.rtl ? 'bottom' : 'bottom-end',
    modifiers: [
      { name: 'arrow', options: { element: arrowElement.current } },
      {
        name: 'offset',
        options: {
          offset: [0, 12]
        }
      }
    ]
  })

  const { styles, attributes } = popper

  const isSlideBar = theme?.header?.components?.cart?.components?.open_strategy?.type === 'slide'

  useEffect(() => {
    const handleProductAdded = () => {
      if (location?.pathname?.includes('/store/')) {
        props.onClick && props.onClick()
      }
    }
    events.on('cart_product_added', handleProductAdded)
    return () => {
      events.off('cart_product_added', handleProductAdded)
    }
  }, [location])

  useEffect(() => {
    // forceUpdate && forceUpdate()
  }, [open, orderState])

  useEffect(() => {
    const checkIfFixed = () => {
      const cartHeaderItem = document.getElementById('cart-header-item')
      const cartHeaderFixed = cartHeaderItem?.classList?.contains('cart-header-fixed')
      setIsFixed(cartHeaderFixed)
    }

    checkIfFixed()

    // Observar cambios en las clases del elemento
    const observer = new MutationObserver(checkIfFixed)
    const cartHeaderItem = document.getElementById('cart-header-item')

    if (cartHeaderItem) {
      observer.observe(cartHeaderItem, {
        attributes: true,
        attributeFilter: ['class']
      })
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  const handleClickOutside = (e) => {
    if (!open) return
    const outsidePopover = !popperElement.current?.contains(e.target)
    const outsidePopoverMenu = !referenceElement.current?.contains(e.target)
    const outsideModal = !window.document.getElementById('app-modals') || !window.document.getElementById('app-modals').contains(e.target)
    if (outsidePopover && outsidePopoverMenu && outsideModal) {
      events.emit('cart_popover_closed')
      props.onClose && props.onClose()
    }
  }

  useEffect(() => {
    window.addEventListener('mouseup', handleClickOutside)
    return () => window.removeEventListener('mouseup', handleClickOutside)
  }, [open])

  useEffect(() => {
    props.onClose()
  }, [auth])

  useEffect(() => {
    if (location && location.pathname.includes('/checkout/')) {
      props.onClose && props.onClose()
    }
  }, [location])

  const getScrollTop = () => {
    if (document.documentElement?.scrollTop > 80) {
      props.onClose && props.onClose()
    }
  }

  useEffect(() => {
    if (location && location.pathname.includes('/store/') && isCustomerMode) {
      window.addEventListener('scroll', getScrollTop)
    }
    return () => {
      window.removeEventListener('scroll', getScrollTop)
    }
  }, [])

  const popStyle = { ...styles.popper, visibility: open ? 'visible' : 'hidden', width: '450px', maxHeight: '70vh', overflowY: 'auto' }
  if (!open) {
    popStyle.transform = 'translate3d(0px, 0px, 0px)'
  }

  return (
    <Wrapper open={open} isFixed={isFixed}>
      <HeaderItem ref={referenceElement} onClick={props.onClick} name='cart-popover' id='cart-header-item' open={open}>
        <span>
          <Basket2Fill />
          {props.carts?.length > 1 && <span>{props.carts?.length}</span>}
          {props.carts?.length === 1 && <span>{props.carts[0].products.length}</span>}
        </span>
      </HeaderItem>
      {isSlideBar
        ? (open
            ? <Modal
                open={open}
                onClose={props.onClose}
                hideCloseDefault
                isSlideBar
                slideBarPosition={theme?.header?.components?.cart?.components?.open_strategy?.position}
              >
                <TitleContainer>
                  <Title>{t('MY_CART', 'My cart')}</Title>
                  <Button outline color='primary' onClick={props.onClose}>
                    <AiOutlineClose /> {t('CLOSE', 'Close')}
                  </Button>
                </TitleContainer>
                <CartContent
                  isCartPopover
                  carts={props.carts}
                  isOrderStateCarts={!!orderState.carts}
                  onClose={props.onClose}
                  setPreorderBusiness={setPreorderBusiness}
                  isOpenCart={open}
                  onClick={props.onClick}
                  isSlideBar={isSlideBar}
                  isCustomerMode={isCustomerMode}
                />
              </Modal>
            : null)
        : (
        <PopoverBody className='cart-popover' ref={popperElement} style={popStyle} {...attributes.popper}>
          <CartContent
            isCartPopover
            carts={props.carts}
            isOrderStateCarts={!!orderState.carts}
            onClose={props.onClose}
            setPreorderBusiness={setPreorderBusiness}
            isOpenCart={open}
            onClick={props.onClick}
            isCustomerMode={isCustomerMode}
          />
          <PopoverArrow key='arrow' ref={arrowElement} style={styles.arrow} />
        </PopoverBody>
          )}
    </Wrapper>
  )
}
